import { render, staticRenderFns } from "./Ai.vue?vue&type=template&id=129127de&scoped=true"
import script from "./Ai.vue?vue&type=script&lang=js"
export * from "./Ai.vue?vue&type=script&lang=js"
import style0 from "./Ai.vue?vue&type=style&index=0&id=129127de&prod&scoped=scoped&lang=less"
import style1 from "./Ai.vue?vue&type=style&index=1&id=129127de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129127de",
  null
  
)

export default component.exports